<button class="mobile-map-toggle" (click)="setMapVisible(!isVisible)">
  <span class="mobile-map-toggle__icon material-icon material-icon--outlined">
    <ng-container *ngIf="isVisible">
      <!-- List icon -->
      list
    </ng-container>
    <ng-container *ngIf="!isVisible">
      <!-- Map Icon -->
      map
    </ng-container>
  </span>
  <span class="mobile-map-toggle__text">
    <ng-container *ngIf="isVisible">
      {{ 'common.list' | i18n }}
    </ng-container>
    <ng-container *ngIf="!isVisible">
      {{ 'common.map' | i18n }}
    </ng-container>
  </span>
</button>
